import Table from './Table';


Table.install = function(Vue) {
  Vue.component(Table.name, Table);
};

export default Table;
